import { Injectable, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { StatusSidebar } from './interfaces/status-sidebar.interface';
@Injectable({
  providedIn: 'root',
})
export class MangoLayoutService implements OnInit {
  statusToogleSidebar: StatusSidebar = {
    statusDesktop: false,
    statusMobile: false,
    mode: window.innerWidth > 768 ? 'desktop' : 'mobile',
  };
  private sendStatusToogleSubject = new Subject<StatusSidebar>();
  sendDataToggleObservable = this.sendStatusToogleSubject.asObservable();
  private emiActionMangoLayout = new Subject<any>();
  actionMangoLayout = this.emiActionMangoLayout.asObservable();

  constructor() {}
  toogleSidebar(status: StatusSidebar) {
    this.statusToogleSidebar = status;
    this.sendStatusToogleSubject.next(this.statusToogleSidebar);
  }
  ngOnInit(): void {}

  emitActionCore(action: string, value: any) {
    this.emiActionMangoLayout.next({ action, value });
  }
}
